var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickNumber($event)}}},[_c('span',{staticClass:"market-shares-ownership__number"},[_vm._v(_vm._s(_vm.numberDisplay))]),_vm._v(" "),_c('span',{staticClass:"market-shares-ownership__mode"},[_vm._v(_vm._s(_vm.mode))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2ab5582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-shares-ownership/market-shares-ownership.vue
// module id = gTKa
// module chunks = 0